import store from '..'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'

export default {
  namespaced: true,
  state () {
    return {
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        var metadata = {
          cacheControl: 'public,max-age=300',
          contentType: payload.blob.type
        }
        var storageRef = null
        var suffix = payload.blob.type.split('/')
        try {
          if (payload.child === 'chats') {
            storageRef = firebase.storage().ref().child(payload.child).child(payload.id).child('data').child(payload.refid + '.' + suffix[1])
          } else {
            storageRef = firebase.storage().ref().child(payload.child).child(payload.id).child(payload.uuid)
          }
        } catch (e) {
          resolve()
        }
        var uploadTask = storageRef.put(payload.blob, metadata)
        uploadTask.on('state_changed', function (snapshot) {
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              break
            case firebase.storage.TaskState.RUNNING:
              break
          }
        }, function (error) {
          if (error) {
            // console.log(error)
          }
          resolve()
        }, function () {
          if (payload.child === 'students' && metadata.contentType === 'application/pdf') {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              const payload = { path: downloadURL, thumbnail: null }
              resolve(payload)
            })
          } else {
            store.dispatch('storage/createThumbnail', {
              path: storageRef.fullPath,
              contentType: payload.blob.type,
              size: 512
            }).then(function (result) {
              if (result === null) {
                resolve()
                return
              }
              firebase.storage().ref().child(result.data).getDownloadURL().then(function (thumbDownloadURL) {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                  const dataPath = result.data.split('/')
                  if (dataPath[0] === 'chats') {
                    var payload = {
                      path: downloadURL,
                      thumbnail: thumbDownloadURL
                    }
                    resolve(payload)
                    // var name = dataPath[3].split('thumb_')
                    // var payload = { content: { path: downloadURL, thumbnail: thumbDownloadURL } }
                    // firebase.firestore().collection(dataPath[0]).doc(dataPath[1]).collection(dataPath[2]).doc(name[1]).update(payload)
                    //   .then(() => {
                    //     // console.log('Document successfully updated!')
                    //     resolve()
                    //   })
                    //   .catch((error) => {
                    //     if (error) {
                    //       // console.log('Error updating document:', error)
                    //     }
                    //     resolve()
                    //   })
                  } else if (dataPath[0] === 'policy') {
                    const payload = { policyImage: { path: downloadURL, thumbnail: thumbDownloadURL } }
                    firebase.firestore().collection('schools').doc(dataPath[1]).update(payload)
                      .then(() => {
                        // console.log('Document successfully updated!')
                        resolve()
                      })
                      .catch((error) => {
                        if (error) {
                          // console.log('Error updating document:', error)
                        }
                        resolve()
                      })
                  } else if (dataPath[0] === 'students') {
                    const payload = { path: downloadURL, thumbnail: thumbDownloadURL }
                    resolve(payload)
                  } else {
                    const payload = { avatar: { path: downloadURL, thumbnail: thumbDownloadURL } }
                    firebase.firestore().collection(dataPath[0]).doc(dataPath[1]).update(payload)
                      .then(() => {
                        // console.log('Document successfully updated!')
                        resolve()
                      })
                      .catch((error) => {
                        if (error) {
                          // console.log('Error updating document:', error)
                        }
                        resolve()
                      })
                  }
                })
              })
            })
          }
        })
      })
    },
    createThumbnail ({ commit }, payload) {
      return new Promise((resolve) => {
        const functions = firebase.app().functions('asia-northeast1')
        const thumbnail = functions.httpsCallable('createThumbnail')
        thumbnail(payload).then(function (result) {
          resolve(result)
        })
      })
    }
  }
}
